import { Outlet, useNavigate } from "react-router-dom"
import Header from "./Header"


import { useGetToken } from "../lib/hooks"
import { useEffect, useState } from "react"
import { getUser, getRecentCases, getUserWorkQueueViews } from "../lib/fetchApi"
import { useDispatch } from "react-redux"
import { notificationActions } from "../store/notifications"
import { userActions } from "../store/user"
import LoadingWrapper from "../components/common/LoadingWrapper"
import { setStorageItem } from "../lib/script"
import { permissionsActions } from "../store/permissions"
import { filterActions } from "../store/filter"
import SystemAlerts from "../components/system/SystemAlerts"
import { useSystemAlertLive, useSystemSettingsUpdated } from "../lib/socketHooks"

const Layout = () => {

    const [showLoading, setShowLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const localStorageToken = localStorage.getItem('token')
    
    const storeToken = useGetToken()
    const isAuthenticated = Boolean(localStorageToken || storeToken)

    useSystemSettingsUpdated(isAuthenticated)
    useSystemAlertLive(isAuthenticated)

    useEffect(() => {
        let isMounted = true;
        if (localStorageToken == storeToken) {
            return;
        }

        const tryToGetUser = async (token) => {
            if (!isMounted) return;

            setShowLoading(true)
            // const user = await getUser(token)

            const [user, recentCases, savedViews] = await Promise.all([
                getUser(token),
                getRecentCases(token),
                getUserWorkQueueViews(token),
            ])

            if (user && user.errorMessage) {
                dispatch(notificationActions.setError(user)) 
                localStorage.removeItem('token')
                navigate('/')
            } else {
                dispatch(permissionsActions.setEditPermissions(user.permissions))


                setStorageItem('user', user)
                dispatch(userActions.setToken(localStorageToken))
                dispatch(userActions.setUser(user))

                if (recentCases && !recentCases.errorMessage) {
                    setStorageItem('recentCases', recentCases)
                }

                dispatch(filterActions.setSavedViews(
                    savedViews && !savedViews.errorMessage && savedViews.views
                        ? savedViews.views
                        : {}
                ))

                // const systemAlerts = await getSystemAlerts(token)
                // if (systemAlerts && !systemAlerts.errorMessage) {
                //     dispatch(systemActions.setSystemAlerts(systemAlerts))
                // }
                
            }  
            setShowLoading(false)
        }

        if (localStorageToken && !storeToken) {
            tryToGetUser(localStorageToken)
        }


        return () => {
            isMounted = false;
        };
    }, [localStorageToken, storeToken]) 


    if (showLoading) {
        return <LoadingWrapper />;
    }
    
    return (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
            <SystemAlerts />
        </>
    );
}

export default Layout